webpackJsonp([87192162464282],{

/***/ 530:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(33);
	
	var _reactRedux = __webpack_require__(21);
	
	var _reactReduxFirebase = __webpack_require__(36);
	
	var _gatsbyLink = __webpack_require__(14);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _app = __webpack_require__(50);
	
	var _reactRouter = __webpack_require__(15);
	
	var _reactCustomScrollbars = __webpack_require__(58);
	
	var _reactHelmet = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FAQPage = function (_React$Component) {
	  _inherits(FAQPage, _React$Component);
	
	  function FAQPage(props) {
	    _classCallCheck(this, FAQPage);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      currentFaq: null
	    };
	    return _this;
	  }
	
	  FAQPage.prototype.setCurrentFaq = function setCurrentFaq(index) {
	    index = this.state.currentFaq == index ? null : index;
	    this.setState({
	      currentFaq: index
	    });
	  };
	
	  FAQPage.prototype.toggleActive = function toggleActive(id) {
	    var container = document.querySelector('#faqs');
	    var active = container.querySelector('.faq-item.active');
	    var newItem = document.querySelector(id);
	    newItem.classList.toggle('active');
	    if (active) {
	      active.classList.remove('active');
	    }
	  };
	
	  FAQPage.prototype.render = function render() {
	    var content = "Loading...";
	    var title = "";
	
	    function Faqs(props) {
	
	      var faqs = props.items.sort(function (a, b) {
	        return a.priority - b.priority;
	      });
	      var items = faqs.map(function (faq, index) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'faq-item ' + (props.parent.state.currentFaq === index ? 'active' : ''),
	            key: 'question' + index,
	            id: 'question' + index },
	          _react2.default.createElement(
	            'h2',
	            { className: 'minor cursor',
	              onClick: function onClick() {
	                return props.parent.toggleActive('#question' + index);
	              } },
	            faq.question
	          ),
	          _react2.default.createElement('p', { dangerouslySetInnerHTML: { __html: faq.answer } })
	        );
	      });
	      return _react2.default.createElement(
	        'div',
	        { className: 'faq-items' },
	        items
	      );
	    }
	    if ((0, _reactReduxFirebase.isLoaded)(this.props.state.faqs)) {
	      title = _react2.default.createElement(
	        'h1',
	        { className: 'major' },
	        this.props.state.faqs.title
	      );
	      content = _react2.default.createElement(Faqs, { items: this.props.state.faqs.items, parent: this });
	    }
	    return _react2.default.createElement(
	      'div',
	      { id: 'faqs', className: 'page faqs' },
	      _react2.default.createElement(
	        _reactHelmet.Helmet,
	        null,
	        _react2.default.createElement(
	          'title',
	          null,
	          'FAQ - Micro-communities of City Car Owners'
	        ),
	        _react2.default.createElement('meta', { name: 'description', content: 'ParkYou! unites micro-communities of city car owners to instantaneously find street parking. We are launching in Summer 2018. Join Us!' })
	      ),
	      _react2.default.createElement(
	        _reactCustomScrollbars.Scrollbars,
	        { className: 'article' },
	        title,
	        content
	      )
	    );
	  };
	
	  return FAQPage;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(_ref) {
	  var app = _ref.app,
	      firebase = _ref.firebase;
	  return {
	    state: {
	      faqs: firebase.data.faqs
	    }
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {};
	};
	
	exports.default = (0, _redux.compose)((0, _reactReduxFirebase.firebaseConnect)(['faqs' // { path: '/todos' } // object notation
	]), (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps))((0, _reactRouter.withRouter)(FAQPage));
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-faq-js-15a0bccc61cf3608dfd1.js